/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTimeOffDto,
  ReplaceWorkingHoursDto,
  ScheduleListForStaffParams,
  ScheduleListTimeOff200,
  ScheduleListTimeOffParams,
  ScheduleListWorkingHoursParams,
  TimeOffResponse,
  UpdateTimeOffDto,
  UpdateWorkingHoursEntryDto,
  WorkingHoursEntryDto,
  WorkingHoursResponse
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * برنامهٔ هفتگی کل کلینیک؛ ورودی موتور نوبت‌دهی. زمان‌ها هم به دقیقه از نیمه‌شب و هم به شکل ساعت خوانا برمی‌گردند.
 * @summary ساعت کاری همهٔ همکاران
 */
export const scheduleListWorkingHours = (
    params?: ScheduleListWorkingHoursParams,
 signal?: AbortSignal
) => {


      return apiClient<WorkingHoursResponse[]>(
      {url: `/api/v1/working-hours`, method: 'GET',
        params, signal
    },
      );
    }




export const getScheduleListWorkingHoursQueryKey = (params?: ScheduleListWorkingHoursParams,) => {
    return [
    `/api/v1/working-hours`, ...(params ? [params] : [])
    ] as const;
    }


export const getScheduleListWorkingHoursQueryOptions = <TData = Awaited<ReturnType<typeof scheduleListWorkingHours>>, TError = unknown>(params?: ScheduleListWorkingHoursParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListWorkingHours>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getScheduleListWorkingHoursQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scheduleListWorkingHours>>> = ({ signal }) => scheduleListWorkingHours(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scheduleListWorkingHours>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ScheduleListWorkingHoursQueryResult = NonNullable<Awaited<ReturnType<typeof scheduleListWorkingHours>>>
export type ScheduleListWorkingHoursQueryError = unknown


export function useScheduleListWorkingHours<TData = Awaited<ReturnType<typeof scheduleListWorkingHours>>, TError = unknown>(
 params: undefined |  ScheduleListWorkingHoursParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListWorkingHours>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof scheduleListWorkingHours>>,
          TError,
          Awaited<ReturnType<typeof scheduleListWorkingHours>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScheduleListWorkingHours<TData = Awaited<ReturnType<typeof scheduleListWorkingHours>>, TError = unknown>(
 params?: ScheduleListWorkingHoursParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListWorkingHours>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof scheduleListWorkingHours>>,
          TError,
          Awaited<ReturnType<typeof scheduleListWorkingHours>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScheduleListWorkingHours<TData = Awaited<ReturnType<typeof scheduleListWorkingHours>>, TError = unknown>(
 params?: ScheduleListWorkingHoursParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListWorkingHours>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ساعت کاری همهٔ همکاران
 */

export function useScheduleListWorkingHours<TData = Awaited<ReturnType<typeof scheduleListWorkingHours>>, TError = unknown>(
 params?: ScheduleListWorkingHoursParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListWorkingHours>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScheduleListWorkingHoursQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary ساعت کاری یک همکار
 */
export const scheduleListForStaff = (
    staffId: string,
    params?: ScheduleListForStaffParams,
 signal?: AbortSignal
) => {


      return apiClient<WorkingHoursResponse[]>(
      {url: `/api/v1/staff/${staffId}/working-hours`, method: 'GET',
        params, signal
    },
      );
    }




export const getScheduleListForStaffQueryKey = (staffId: string,
    params?: ScheduleListForStaffParams,) => {
    return [
    `/api/v1/staff/${staffId}/working-hours`, ...(params ? [params] : [])
    ] as const;
    }


export const getScheduleListForStaffQueryOptions = <TData = Awaited<ReturnType<typeof scheduleListForStaff>>, TError = void>(staffId: string,
    params?: ScheduleListForStaffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListForStaff>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getScheduleListForStaffQueryKey(staffId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scheduleListForStaff>>> = ({ signal }) => scheduleListForStaff(staffId,params, signal);





   return  { queryKey, queryFn, enabled: staffId !== null && staffId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scheduleListForStaff>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ScheduleListForStaffQueryResult = NonNullable<Awaited<ReturnType<typeof scheduleListForStaff>>>
export type ScheduleListForStaffQueryError = void


export function useScheduleListForStaff<TData = Awaited<ReturnType<typeof scheduleListForStaff>>, TError = void>(
 staffId: string,
    params: undefined |  ScheduleListForStaffParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListForStaff>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof scheduleListForStaff>>,
          TError,
          Awaited<ReturnType<typeof scheduleListForStaff>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScheduleListForStaff<TData = Awaited<ReturnType<typeof scheduleListForStaff>>, TError = void>(
 staffId: string,
    params?: ScheduleListForStaffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListForStaff>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof scheduleListForStaff>>,
          TError,
          Awaited<ReturnType<typeof scheduleListForStaff>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScheduleListForStaff<TData = Awaited<ReturnType<typeof scheduleListForStaff>>, TError = void>(
 staffId: string,
    params?: ScheduleListForStaffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListForStaff>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ساعت کاری یک همکار
 */

export function useScheduleListForStaff<TData = Awaited<ReturnType<typeof scheduleListForStaff>>, TError = void>(
 staffId: string,
    params?: ScheduleListForStaffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListForStaff>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScheduleListForStaffQueryOptions(staffId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * کل شیفت‌های این همکار را با فهرست ارسالی جایگزین می‌کند — همان کاری که ذخیرهٔ جدول برنامهٔ هفتگی در پنل انجام می‌دهد. فهرست خالی یعنی این همکار هیچ شیفتی ندارد. چند شیفت در یک روز مجاز است، ولی هم‌پوشانی نه.
 * @summary جایگزینی کامل برنامهٔ هفتگی یک همکار
 */
export const scheduleReplaceWorkingHours = (
    staffId: string,
    replaceWorkingHoursDto: ReplaceWorkingHoursDto,
 signal?: AbortSignal
) => {


      return apiClient<WorkingHoursResponse[]>(
      {url: `/api/v1/staff/${staffId}/working-hours`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: replaceWorkingHoursDto, signal
    },
      );
    }




export const getScheduleReplaceWorkingHoursMutationKey = () => ['scheduleReplaceWorkingHours'] as const;

export const getScheduleReplaceWorkingHoursMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleReplaceWorkingHours>>, TError,ScheduleReplaceWorkingHoursMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scheduleReplaceWorkingHours>>, TError,ScheduleReplaceWorkingHoursMutationVariables, TContext> => {

const mutationKey = getScheduleReplaceWorkingHoursMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleReplaceWorkingHours>>, ScheduleReplaceWorkingHoursMutationVariables> = (props) => {
          const {staffId,data} = props ?? {};

          return  scheduleReplaceWorkingHours(staffId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleReplaceWorkingHoursMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleReplaceWorkingHours>>>
    export type ScheduleReplaceWorkingHoursMutationBody = ReplaceWorkingHoursDto
    export type ScheduleReplaceWorkingHoursMutationError = void
    export type ScheduleReplaceWorkingHoursMutationVariables = {staffId: string;data: ReplaceWorkingHoursDto}

    /**
 * @summary جایگزینی کامل برنامهٔ هفتگی یک همکار
 */
export const useScheduleReplaceWorkingHours = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleReplaceWorkingHours>>, TError,ScheduleReplaceWorkingHoursMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleReplaceWorkingHours>>,
        TError,
        ScheduleReplaceWorkingHoursMutationVariables,
        TContext
      > => {
      return useMutation(getScheduleReplaceWorkingHoursMutationOptions(options), queryClient);
    }
    /**
 * شیفت تازه در برابر همهٔ شیفت‌های همان روزِ همان همکار بررسی می‌شود.
 * @summary افزودن یک شیفت
 */
export const scheduleAddWorkingHours = (
    staffId: string,
    workingHoursEntryDto: WorkingHoursEntryDto,
 signal?: AbortSignal
) => {


      return apiClient<WorkingHoursResponse>(
      {url: `/api/v1/staff/${staffId}/working-hours`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workingHoursEntryDto, signal
    },
      );
    }




export const getScheduleAddWorkingHoursMutationKey = () => ['scheduleAddWorkingHours'] as const;

export const getScheduleAddWorkingHoursMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleAddWorkingHours>>, TError,ScheduleAddWorkingHoursMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scheduleAddWorkingHours>>, TError,ScheduleAddWorkingHoursMutationVariables, TContext> => {

const mutationKey = getScheduleAddWorkingHoursMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleAddWorkingHours>>, ScheduleAddWorkingHoursMutationVariables> = (props) => {
          const {staffId,data} = props ?? {};

          return  scheduleAddWorkingHours(staffId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleAddWorkingHoursMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleAddWorkingHours>>>
    export type ScheduleAddWorkingHoursMutationBody = WorkingHoursEntryDto
    export type ScheduleAddWorkingHoursMutationError = void
    export type ScheduleAddWorkingHoursMutationVariables = {staffId: string;data: WorkingHoursEntryDto}

    /**
 * @summary افزودن یک شیفت
 */
export const useScheduleAddWorkingHours = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleAddWorkingHours>>, TError,ScheduleAddWorkingHoursMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleAddWorkingHours>>,
        TError,
        ScheduleAddWorkingHoursMutationVariables,
        TContext
      > => {
      return useMutation(getScheduleAddWorkingHoursMutationOptions(options), queryClient);
    }
    /**
 * @summary ویرایش یک شیفت
 */
export const scheduleUpdateWorkingHours = (
    id: string,
    updateWorkingHoursEntryDto: UpdateWorkingHoursEntryDto,
 signal?: AbortSignal
) => {


      return apiClient<WorkingHoursResponse>(
      {url: `/api/v1/working-hours/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateWorkingHoursEntryDto, signal
    },
      );
    }




export const getScheduleUpdateWorkingHoursMutationKey = () => ['scheduleUpdateWorkingHours'] as const;

export const getScheduleUpdateWorkingHoursMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleUpdateWorkingHours>>, TError,ScheduleUpdateWorkingHoursMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scheduleUpdateWorkingHours>>, TError,ScheduleUpdateWorkingHoursMutationVariables, TContext> => {

const mutationKey = getScheduleUpdateWorkingHoursMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleUpdateWorkingHours>>, ScheduleUpdateWorkingHoursMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  scheduleUpdateWorkingHours(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleUpdateWorkingHoursMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleUpdateWorkingHours>>>
    export type ScheduleUpdateWorkingHoursMutationBody = UpdateWorkingHoursEntryDto
    export type ScheduleUpdateWorkingHoursMutationError = void
    export type ScheduleUpdateWorkingHoursMutationVariables = {id: string;data: UpdateWorkingHoursEntryDto}

    /**
 * @summary ویرایش یک شیفت
 */
export const useScheduleUpdateWorkingHours = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleUpdateWorkingHours>>, TError,ScheduleUpdateWorkingHoursMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleUpdateWorkingHours>>,
        TError,
        ScheduleUpdateWorkingHoursMutationVariables,
        TContext
      > => {
      return useMutation(getScheduleUpdateWorkingHoursMutationOptions(options), queryClient);
    }
    /**
 * @summary حذف یک شیفت
 */
export const scheduleRemoveWorkingHours = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/working-hours/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getScheduleRemoveWorkingHoursMutationKey = () => ['scheduleRemoveWorkingHours'] as const;

export const getScheduleRemoveWorkingHoursMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleRemoveWorkingHours>>, TError,ScheduleRemoveWorkingHoursMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scheduleRemoveWorkingHours>>, TError,ScheduleRemoveWorkingHoursMutationVariables, TContext> => {

const mutationKey = getScheduleRemoveWorkingHoursMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleRemoveWorkingHours>>, ScheduleRemoveWorkingHoursMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  scheduleRemoveWorkingHours(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleRemoveWorkingHoursMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleRemoveWorkingHours>>>

    export type ScheduleRemoveWorkingHoursMutationError = void
    export type ScheduleRemoveWorkingHoursMutationVariables = {id: string}

    /**
 * @summary حذف یک شیفت
 */
export const useScheduleRemoveWorkingHours = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleRemoveWorkingHours>>, TError,ScheduleRemoveWorkingHoursMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleRemoveWorkingHours>>,
        TError,
        ScheduleRemoveWorkingHoursMutationVariables,
        TContext
      > => {
      return useMutation(getScheduleRemoveWorkingHoursMutationOptions(options), queryClient);
    }
    /**
 * با from/to هر مرخصی‌ای که با آن بازه هم‌پوشانی دارد برمی‌گردد، نه فقط آن‌هایی که کاملاً داخل بازه‌اند. مرخصی بدون همکار یعنی کل کلینیک تعطیل است.
 * @summary فهرست مرخصی‌ها
 */
export const scheduleListTimeOff = (
    params?: ScheduleListTimeOffParams,
 signal?: AbortSignal
) => {


      return apiClient<ScheduleListTimeOff200>(
      {url: `/api/v1/time-off`, method: 'GET',
        params, signal
    },
      );
    }




export const getScheduleListTimeOffQueryKey = (params?: ScheduleListTimeOffParams,) => {
    return [
    `/api/v1/time-off`, ...(params ? [params] : [])
    ] as const;
    }


export const getScheduleListTimeOffQueryOptions = <TData = Awaited<ReturnType<typeof scheduleListTimeOff>>, TError = unknown>(params?: ScheduleListTimeOffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListTimeOff>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getScheduleListTimeOffQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scheduleListTimeOff>>> = ({ signal }) => scheduleListTimeOff(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scheduleListTimeOff>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ScheduleListTimeOffQueryResult = NonNullable<Awaited<ReturnType<typeof scheduleListTimeOff>>>
export type ScheduleListTimeOffQueryError = unknown


export function useScheduleListTimeOff<TData = Awaited<ReturnType<typeof scheduleListTimeOff>>, TError = unknown>(
 params: undefined |  ScheduleListTimeOffParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListTimeOff>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof scheduleListTimeOff>>,
          TError,
          Awaited<ReturnType<typeof scheduleListTimeOff>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScheduleListTimeOff<TData = Awaited<ReturnType<typeof scheduleListTimeOff>>, TError = unknown>(
 params?: ScheduleListTimeOffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListTimeOff>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof scheduleListTimeOff>>,
          TError,
          Awaited<ReturnType<typeof scheduleListTimeOff>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScheduleListTimeOff<TData = Awaited<ReturnType<typeof scheduleListTimeOff>>, TError = unknown>(
 params?: ScheduleListTimeOffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListTimeOff>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست مرخصی‌ها
 */

export function useScheduleListTimeOff<TData = Awaited<ReturnType<typeof scheduleListTimeOff>>, TError = unknown>(
 params?: ScheduleListTimeOffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleListTimeOff>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScheduleListTimeOffQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * بدون staffId، کل کلینیک در آن بازه تعطیل می‌شود. با isAllDay بازه تا پایان روز پایانی به وقت تهران گسترش می‌یابد.
 * @summary ثبت مرخصی
 */
export const scheduleCreateTimeOff = (
    createTimeOffDto: CreateTimeOffDto,
 signal?: AbortSignal
) => {


      return apiClient<TimeOffResponse>(
      {url: `/api/v1/time-off`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTimeOffDto, signal
    },
      );
    }




export const getScheduleCreateTimeOffMutationKey = () => ['scheduleCreateTimeOff'] as const;

export const getScheduleCreateTimeOffMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleCreateTimeOff>>, TError,ScheduleCreateTimeOffMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scheduleCreateTimeOff>>, TError,ScheduleCreateTimeOffMutationVariables, TContext> => {

const mutationKey = getScheduleCreateTimeOffMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleCreateTimeOff>>, ScheduleCreateTimeOffMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  scheduleCreateTimeOff(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleCreateTimeOffMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleCreateTimeOff>>>
    export type ScheduleCreateTimeOffMutationBody = CreateTimeOffDto
    export type ScheduleCreateTimeOffMutationError = void
    export type ScheduleCreateTimeOffMutationVariables = {data: CreateTimeOffDto}

    /**
 * @summary ثبت مرخصی
 */
export const useScheduleCreateTimeOff = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleCreateTimeOff>>, TError,ScheduleCreateTimeOffMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleCreateTimeOff>>,
        TError,
        ScheduleCreateTimeOffMutationVariables,
        TContext
      > => {
      return useMutation(getScheduleCreateTimeOffMutationOptions(options), queryClient);
    }
    /**
 * @summary یک مرخصی
 */
export const scheduleGetTimeOff = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<TimeOffResponse>(
      {url: `/api/v1/time-off/${id}`, method: 'GET', signal
    },
      );
    }




export const getScheduleGetTimeOffQueryKey = (id: string,) => {
    return [
    `/api/v1/time-off/${id}`
    ] as const;
    }


export const getScheduleGetTimeOffQueryOptions = <TData = Awaited<ReturnType<typeof scheduleGetTimeOff>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleGetTimeOff>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getScheduleGetTimeOffQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scheduleGetTimeOff>>> = ({ signal }) => scheduleGetTimeOff(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scheduleGetTimeOff>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ScheduleGetTimeOffQueryResult = NonNullable<Awaited<ReturnType<typeof scheduleGetTimeOff>>>
export type ScheduleGetTimeOffQueryError = void


export function useScheduleGetTimeOff<TData = Awaited<ReturnType<typeof scheduleGetTimeOff>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleGetTimeOff>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof scheduleGetTimeOff>>,
          TError,
          Awaited<ReturnType<typeof scheduleGetTimeOff>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScheduleGetTimeOff<TData = Awaited<ReturnType<typeof scheduleGetTimeOff>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleGetTimeOff>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof scheduleGetTimeOff>>,
          TError,
          Awaited<ReturnType<typeof scheduleGetTimeOff>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScheduleGetTimeOff<TData = Awaited<ReturnType<typeof scheduleGetTimeOff>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleGetTimeOff>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary یک مرخصی
 */

export function useScheduleGetTimeOff<TData = Awaited<ReturnType<typeof scheduleGetTimeOff>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scheduleGetTimeOff>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScheduleGetTimeOffQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * همکار مرخصی قابل تغییر نیست؛ برای جابه‌جایی، مرخصی را حذف و دوباره ثبت کنید.
 * @summary ویرایش مرخصی
 */
export const scheduleUpdateTimeOff = (
    id: string,
    updateTimeOffDto: UpdateTimeOffDto,
 signal?: AbortSignal
) => {


      return apiClient<TimeOffResponse>(
      {url: `/api/v1/time-off/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTimeOffDto, signal
    },
      );
    }




export const getScheduleUpdateTimeOffMutationKey = () => ['scheduleUpdateTimeOff'] as const;

export const getScheduleUpdateTimeOffMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleUpdateTimeOff>>, TError,ScheduleUpdateTimeOffMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scheduleUpdateTimeOff>>, TError,ScheduleUpdateTimeOffMutationVariables, TContext> => {

const mutationKey = getScheduleUpdateTimeOffMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleUpdateTimeOff>>, ScheduleUpdateTimeOffMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  scheduleUpdateTimeOff(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleUpdateTimeOffMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleUpdateTimeOff>>>
    export type ScheduleUpdateTimeOffMutationBody = UpdateTimeOffDto
    export type ScheduleUpdateTimeOffMutationError = void
    export type ScheduleUpdateTimeOffMutationVariables = {id: string;data: UpdateTimeOffDto}

    /**
 * @summary ویرایش مرخصی
 */
export const useScheduleUpdateTimeOff = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleUpdateTimeOff>>, TError,ScheduleUpdateTimeOffMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleUpdateTimeOff>>,
        TError,
        ScheduleUpdateTimeOffMutationVariables,
        TContext
      > => {
      return useMutation(getScheduleUpdateTimeOffMutationOptions(options), queryClient);
    }
    /**
 * @summary حذف مرخصی
 */
export const scheduleRemoveTimeOff = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/time-off/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getScheduleRemoveTimeOffMutationKey = () => ['scheduleRemoveTimeOff'] as const;

export const getScheduleRemoveTimeOffMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleRemoveTimeOff>>, TError,ScheduleRemoveTimeOffMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scheduleRemoveTimeOff>>, TError,ScheduleRemoveTimeOffMutationVariables, TContext> => {

const mutationKey = getScheduleRemoveTimeOffMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleRemoveTimeOff>>, ScheduleRemoveTimeOffMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  scheduleRemoveTimeOff(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleRemoveTimeOffMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleRemoveTimeOff>>>

    export type ScheduleRemoveTimeOffMutationError = void
    export type ScheduleRemoveTimeOffMutationVariables = {id: string}

    /**
 * @summary حذف مرخصی
 */
export const useScheduleRemoveTimeOff = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleRemoveTimeOff>>, TError,ScheduleRemoveTimeOffMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleRemoveTimeOff>>,
        TError,
        ScheduleRemoveTimeOffMutationVariables,
        TContext
      > => {
      return useMutation(getScheduleRemoveTimeOffMutationOptions(options), queryClient);
    }
